import { useTranslation } from 'react-i18next';
import { AREA_PALETTE } from './areaPalette';
import type { IPathPaletteProps } from './IPathPaletteProps';

/** Палітра кольору напряму під рядком (прототип v4 pr.palette): «Колір · діти успадковують його», 10 кольорів, «Успадкувати» / «Без кольору». */
export function PathPalette({ node, depth, editor }: IPathPaletteProps) {
  const { t } = useTranslation();
  return (
    <div className="cu-pathform" style={{ paddingLeft: depth * 24 + 40 }}>
      <span className="sp-muted cu-pathform__label">{t('sysCust.paths.colourHint')}</span>
      {AREA_PALETTE.map((col) => (
        <button key={col} type="button" className="cu-pathcol" aria-label={t('sysCust.paths.colourOf', { colour: col })}
          style={{ background: col, boxShadow: node.color === col ? `0 0 0 2px var(--surface), 0 0 0 4px ${col}` : undefined }} onClick={() => editor.setColor(node, col)} />
      ))}
      {node.color && <button type="button" className="sp-btn cu-pathform__btn" onClick={() => editor.setColor(node, '')}>{t(depth ? 'sysCust.paths.inherit' : 'sysCust.paths.noColour')}</button>}
    </div>
  );
}
